import React from 'react';

import SourceBoxTd from './Td';

class SourceBoxTable extends React.Component {
  renderThead(data) {
    const thList = data.map((item, index) => {
      return (
        <th key={ `th-${index}` }>
          { item.label || item }
        </th>
      );
    });

    return (
      <thead>
        <tr className="reactable-column-header">
          { thList }
        </tr>
      </thead>
    );
  }

  renderTbody(keys, data) {
    const trList = data.map((item, index) => {
      return (
        <tr key={ `tr-${index}` }>
          { this.renderTds(keys, item) }
        </tr>
      );
    });

    return (
      <tbody className="reactable-data">
        { trList }
      </tbody>
    );
  }

  renderTds(keys, data) {
    return keys.map((key, index) => {
      return (
        <SourceBoxTd
          key={ `td-${index}` }
          hideLarge={ this.props.hideLargeDescriptions }
        >
          { data[key] }
        </SourceBoxTd>
      );
    });
  }

  render() {
    const { data, columns } = this.props;

    const columnKeys = columns.map(item => item.key || item);

    return (
      <table className="table">
        { this.renderThead(columns) }
        { this.renderTbody(columnKeys, data) }
      </table>
    );
  }
}

export default SourceBoxTable;



// WEBPACK FOOTER //
// ./src/components/SourceBox/Table/index.js